/**
 * The generator controller's mode, its own module so the Overview's `data-centre.ts` can read it
 * without importing the Analytics' arithmetic (which imports the Overview's bands back).
 */
import type { LatestRow } from '@/lib/api/types';
import { valueLabel } from '@/lib/telemetry/value-label';

/**
 * THE CONTROLLER'S MODE (2026-10-16): a standby set left in Manual or Stop does not start when the
 * grid goes, whatever its fuel — the commonest way a bank's generator fails on the day. Read from
 * `control_mode` THROUGH ITS VALUE LABELS (`valueLabel`), never a code table here: the codes are
 * the controller's, and the gateway may pass them on renumbered, so the names are set where every
 * other code is named, in Device management. A mode named "Auto…" will start by itself; any other
 * named mode will not; a code nobody has named yet is shown as itself and judged neither way.
 */
export interface GeneratorMode {
  /** The mode's name, or the code itself while nobody has named it. */
  text: string;
  named: boolean;
  /** Will it start by itself: true for a mode named Auto, false for another named mode, null unnamed. */
  auto: boolean | null;
}

export function generatorMode(row: Pick<LatestRow, 'labels' | 'labelKind' | 'value' | 'raw' | 'valueText'> | undefined): GeneratorMode | null {
  if (!row || (row.value === null && (row.raw ?? null) === null)) return null;
  const v = valueLabel(row);
  if (!v.labelled) return { text: v.text, named: false, auto: null };
  return { text: v.text, named: true, auto: /\bauto/i.test(v.text) };
}
